export enum BufferUsageType {
  StaticDraw = WebGLRenderingContext.STATIC_DRAW,
  DynamicDraw = WebGLRenderingContext.DYNAMIC_DRAW,
  StreamDraw = WebGLRenderingContext.STREAM_DRAW
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/BufferUsageType.ts